'use client'

import { setToastRef } from "@/vars/global"
import { Toast } from "primereact/toast"
import { useEffect, useRef } from "react"

export default function ClientToast () {
  const tRef = useRef<Toast>(null);

  useEffect(() => {
    setToastRef(tRef);
  }, [tRef])
  
  return (
    <Toast ref={tRef} />
  )
}